export default "__VITE_ASSET__BEnPosAR__"